document.addEventListener('DOMContentLoaded', function () {
  var revealEls = document.querySelectorAll('.qt-reveal, .qt-slide-right');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var el = entry.target;
        if (entry.isIntersecting) {
          el.classList.add('is-visible');
        }
      });
    }, { threshold: 0.2 });

    revealEls.forEach(function (el, index) {
      var group = el.closest('[data-qt-stagger]');
      if (group) {
        var siblings = Array.from(group.querySelectorAll('.qt-reveal, .qt-slide-right'));
        var idx = siblings.indexOf(el);
        var delay = (idx > -1 ? idx : index) % 6;
        el.style.transitionDelay = (delay * 120) + 'ms';
      }
      revealObserver.observe(el);
    });
  }

  var blurTargets = document.querySelectorAll('.qt-blur-swap');
  if (blurTargets.length && 'IntersectionObserver' in window) {
    var blurObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle('is-blurred', entry.isIntersecting);
      });
    }, { threshold: 0.5 });
    blurTargets.forEach(function (el) { blurObserver.observe(el); });
  }

  var welcomeSection = document.querySelector('[data-qt-welcome]');
  if (welcomeSection) {
    var checkWelcomeScroll = function() {
      var scrollY = window.scrollY || window.pageYOffset;
      var startScroll = 10; 
      var endScroll = 450; 
      
      var progress = (scrollY - startScroll) / (endScroll - startScroll);
      progress = Math.max(0, Math.min(1, progress));
      
      welcomeSection.classList.remove('step-1', 'step-2', 'step-3', 'step-4');

      if (progress < 0.25) {
        welcomeSection.classList.add('step-1');
      } else if (progress >= 0.25 && progress < 0.45) {
        welcomeSection.classList.add('step-2');
      } else if (progress >= 0.45 && progress < 0.65) {
        welcomeSection.classList.add('step-3');
      } else {
        welcomeSection.classList.add('step-4');
      }
    };

    window.addEventListener('scroll', checkWelcomeScroll, { passive: true });
    window.addEventListener('resize', checkWelcomeScroll, { passive: true });
    checkWelcomeScroll();
  }

  // Retreats Animation Map
  var retreatsSection = document.querySelector('.qt-retreats');
  if (retreatsSection) {
    var checkRetreatsScroll = function() {
      var rect = retreatsSection.getBoundingClientRect();
      var windowHeight = window.innerHeight;
      
      var start = windowHeight * 0.9;
      var end = windowHeight * 0.2;
      
      var progress = (start - rect.top) / (start - end);
      progress = Math.max(0, Math.min(1, progress));
      
      retreatsSection.classList.remove('retreat-step-1', 'retreat-step-2', 'retreat-step-3', 'retreat-step-4');

      if (progress < 0.25) {
        retreatsSection.classList.add('retreat-step-1');
      } else if (progress >= 0.25 && progress < 0.5) {
        retreatsSection.classList.add('retreat-step-2');
      } else if (progress >= 0.5 && progress < 0.75) {
        retreatsSection.classList.add('retreat-step-3');
      } else {
        retreatsSection.classList.add('retreat-step-4');
      }
    };

    window.addEventListener('scroll', checkRetreatsScroll, { passive: true });
    window.addEventListener('resize', checkRetreatsScroll, { passive: true });
    checkRetreatsScroll();
  }

  // Plan Your Trip
  var planTripSection = document.querySelector('.qt-plan-trip');
  var planTripLeft = document.querySelector('[data-qt-plan-trip-left]');
  var planTripRight = document.querySelector('[data-qt-plan-trip-right]');

  if (planTripSection && planTripLeft && planTripRight) {
    var updatePlanTripParallax = function () {
      var rect = planTripSection.getBoundingClientRect();
      var windowHeight = window.innerHeight;
      var viewportMid = windowHeight * 0.5;
      var rampZone = Math.max(350, windowHeight * 0.6);

      var enterHidden = Math.max(0, Math.min(1, (rect.top - viewportMid) / rampZone));
      var exitHidden = Math.max(0, Math.min(1, (viewportMid - rect.bottom) / rampZone));
      var hiddenAmount = Math.max(enterHidden, exitHidden);

      var driftDistance = 220;
      var leftOffset = -hiddenAmount * driftDistance;
      var rightOffset = hiddenAmount * driftDistance;

      planTripLeft.style.transform = 'translateX(' + leftOffset + 'px)';
      planTripRight.style.transform = 'translateX(' + rightOffset + 'px)';
    };

    window.addEventListener('scroll', updatePlanTripParallax, { passive: true });
    window.addEventListener('resize', updatePlanTripParallax, { passive: true });
    updatePlanTripParallax();
  }

  var calendarSection = document.querySelector('[data-qt-calendar-section]');
  var calendarContent = document.querySelector('[data-qt-calendar-content]');
  var calendarShadow  = document.querySelector('.qt-calendar-shadow');
  var townLayer       = document.querySelector('[data-qt-town-layer]');

  function clamp01(v) { return Math.max(0, Math.min(1, v)); }

  if (calendarSection && calendarContent && calendarShadow && townLayer) {

    var CAL_THRESHOLDS = [0, 0.15, 0.45, 0.62, 0.76, 0.88];

    function getTargetStep(progress) {
      for (var s = CAL_THRESHOLDS.length - 1; s >= 0; s--) {
        if (progress >= CAL_THRESHOLDS[s]) return s + 1;
      }
      return 1;
    }

    var currentCalStep = 1;
    var targetCalStep  = 1;
    var rafId          = null;
    var lastStepAt     = 0;
    var STEP_INTERVAL  = 180;

    function applyStep(step) {
      if (step === currentCalStep) return;
      calendarSection.classList.remove(
        'calendar-step-1','calendar-step-2','calendar-step-3',
        'calendar-step-4','calendar-step-5','calendar-step-6'
      );
      calendarSection.classList.add('calendar-step-' + step);
      currentCalStep = step;
    }

    function tick(timestamp) {
      if (currentCalStep === targetCalStep) {
        rafId = null;
        return;
      }
      if (timestamp - lastStepAt >= STEP_INTERVAL) {
        var next = currentCalStep < targetCalStep
          ? currentCalStep + 1
          : currentCalStep - 1;
        applyStep(next);
        lastStepAt = timestamp;
      }
      rafId = requestAnimationFrame(tick);
    }

    function startTick() {
      if (rafId === null && currentCalStep !== targetCalStep) {
        lastStepAt = performance.now() - STEP_INTERVAL;
        rafId = requestAnimationFrame(tick);
      }
    }

    var updateCalendarPin = function () {
      var isDesktop = window.matchMedia('(min-width: 1023px)').matches;

      if (!isDesktop) {
        if (rafId !== null) {
          cancelAnimationFrame(rafId);
          rafId = null;
        }
        calendarSection.classList.remove(
          'calendar-step-2','calendar-step-3',
          'calendar-step-4','calendar-step-5','calendar-step-6'
        );
        calendarSection.classList.add('calendar-step-1');
        currentCalStep = 1;
        targetCalStep = 1;
        return;
      }

      var visualHeight = window.innerHeight;
      var rect         = calendarSection.getBoundingClientRect();
      var scrollable   = rect.height - visualHeight;
      if (scrollable <= 0) scrollable = 1;

      var progress    = clamp01(-rect.top / scrollable);
      var newTarget   = getTargetStep(progress);

      if (newTarget !== targetCalStep) {
        targetCalStep = newTarget;
        startTick();
      }
    };

    calendarSection.classList.add('calendar-step-1');

    window.addEventListener('scroll', updateCalendarPin, { passive: true });
    window.addEventListener('resize', updateCalendarPin, { passive: true });
    updateCalendarPin();
  }


  // Dynamic month calendar
  var calElem = document.querySelector('[data-qt-calendar]');
  if (calElem) {
    var currentDate = new Date();
    var selectedYear = parseInt(calElem.getAttribute('data-year'), 10);
    var selectedMonth = parseInt(calElem.getAttribute('data-month'), 10);
    var month = (isNaN(selectedMonth) || selectedMonth === 0) ? currentDate.getMonth() : selectedMonth - 1;
    var year = isNaN(selectedYear) ? currentDate.getFullYear() : selectedYear;
    if (selectedMonth === 0) {
      year = currentDate.getFullYear();
    }
    var highlight = calElem.getAttribute('data-highlight') || '';
    var highlightDates = highlight.split(',').map(function (item) { return item.trim(); }).filter(Boolean);

    var grid = calElem.querySelector('[data-qt-calendar-grid]');
    var label = calElem.querySelector('[data-qt-calendar-label]');
    var prevBtn = calElem.querySelector('[data-qt-calendar-prev]');
    var nextBtn = calElem.querySelector('[data-qt-calendar-next]');
    var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    function renderCal() {
      var first = new Date(year, month, 1);
      var startDay = first.getDay();
      var daysInMonth = new Date(year, month + 1, 0).getDate();
      var prevDays = new Date(year, month, 0).getDate();
      var cells = [];

      for (var i = startDay - 1; i >= 0; i--) {
        cells.push({ day: prevDays - i, muted: true });
      }
      for (var d = 1; d <= daysInMonth; d++) {
        var iso = year + '-' + String(month + 1).padStart(2, '0') + '-' + String(d).padStart(2, '0');
        cells.push({ day: d, muted: false, iso: iso });
      }
      while (cells.length % 7 !== 0) {
        cells.push({ day: cells.length - (startDay + daysInMonth) + 1, muted: true });
      }

      label.textContent = monthNames[month] + ' ' + year;
      grid.innerHTML = cells.map(function (cell) {
        var isHighlighted = highlightDates.indexOf(cell.iso) > -1;
        var base = 'flex items-center justify-center h-[42px] md:h-[67px] text-sm md:heading-7';
        var toneClass = cell.muted ? 'text-black/30 bg-black/5 border border-gray-300' : 'text-black font-medium border border-gray-300';
        if (isHighlighted) {
          toneClass = 'bg-[#E34848] text-white font-bold border border-gray-300';
        }
        return '<div class="' + base + ' ' + toneClass + '">' + cell.day + '</div>';
      }).join('');
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        month -= 1;
        if (month < 0) { month = 11; year -= 1; }
        renderCal();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        month += 1;
        if (month > 11) { month = 0; year += 1; }
        renderCal();
      });
    }
    renderCal();
  }

});